<div class="row icon-box">
  <div class="col-3 col-md-3 col-lg-3 col-sm-2">
    <a href="javascript:void(0);" (click)="openPriceDropModal()">
      <img src="/assets/images/icons/Pricedrop.svg" aria-hidden="true" />
      <span>Price drop</span>
    </a>
  </div>
  <div class="col-3 col-md-3 col-lg-3 col-sm-2" *ngIf="makeOfferEnabled && sellerOfferEnabled">
    <a href="javascript:void(0);" (click)="openOffers()">
      <img src="/assets/images/icons/offers.svg" aria-hidden="true" />
      <span>See offers</span>
    </a>
  </div>
  <div class="col-3 col-md-3 col-lg-3 col-sm-2">
    <a href="javascript:void(0);" (click)="openEditModal()">
      <img src="/assets/images/icons/Edit.svg" aria-hidden="true" />
      <span>Edit item</span>
    </a>
  </div>
  <div class="col-3 col-md-3 col-lg-3 col-sm-2">
    <a href="javascript:void(0);" (click)="openTrashPopUp()">
      <img src="/assets/images/icons/remove.svg" aria-hidden="true" />
      <span>Remove item</span>
    </a>
  </div>
</div>

<div class="items-model-up">
  <div class="modal" id="trash-pupup" [style.display]="trashModel ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div>
          <button type="button" class="close" data-dismiss="modal" (click)="displayButton ? hidePopUp() : refresh()">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <h2>{{ popUpHeading }}</h2>
          <div class="product-details">
            <div class="popup-product-image">
              <img *ngIf="product.imgix_image_url != ''" src="{{ product.imgix_image_url }}" class="product-image" />
            </div>
            <div class="product-brand">
              {{ product.brand_name || ('Unnamed Brand' | translate) }}
            </div>
            <div class="product-name" [title]="product.name">
              {{ product.name || ('Unnamed Product' | translate) }}
            </div>
          </div>
          <div class="buttom-box" [style.display]="displayButton ? 'block' : 'none'">
            <button type="button" class="btn btn-dark yes-button" (click)="displayButton ? trashProductItem() : ''">
              {{ 'YES' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-light no-button"
              data-dismiss="modal"
              (click)="displayButton ? hidePopUp() : refresh()"
            >
              {{ 'No' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
